<template>
    <van-row>
      <van-nav-bar title="打开小程序"/>
      <van-col span="24">
        <div class="login-img">
          <van-image
            round
            width="6rem"
            height="6rem"
            src="https://qiniu.xzypapp.com/wechat/logo.png"
          />
        </div>
        <van-button class="btn" type="primary" @click="downloadButton">打开微信小程序</van-button>
      </van-col>
    </van-row>
  </template>
  <script>
  export default {
    data() {
      return {
        url: "",
      };
    },
  
    mounted() {
      this.getWechatUrlScheme();
    },
    methods: {
      getWechatUrlScheme() {
        this.axios({
          method: "post",
          url: "api/user/getWechatUrlScheme",
          data: {
            path: "/pages/recycle/index",
            query: "id=725&type=scheme",
            version: "release",
          },
        }).then(res => {
          location.href = res.data.data;
          this.url = res.data.data;
        });
      },
      downloadButton() {
        location.href = this.url;
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .van-nav-bar {
    background-image: linear-gradient(to right, #f09852, #ec6637, #ea3e26);
    /deep/.van-nav-bar__title {
      color: #fff;
      font-weight: 600;
    }
  }
  
  .login-img {
    margin-top: 50px;
  }
  .btn{
      margin-top: 50px;
    background: #07C160;
  }
  </style>


// WEBPACK FOOTER //
// src/components/recycle.vue